export default __webpack_public_path__ + "static/media/renderforest.185d25cb.webp";